<template>
    <div>
      <b-card>
        <h4 class="text-primary text-center mb-2"> Select Assessment</h4>
        <hr>
        <b-row class="text-secondary font-weight-bolder">
            <b-col md="6" sm="6"> Title </b-col>
            <b-col md="2" sm="2"> Start Date</b-col>
            <b-col md="2" sm="2"> End Date</b-col>
            <b-col md="2" sm="2"> </b-col>
            
        </b-row>
        <hr>
        <div v-for="(assessment, index) in assessments" :key="index">
            <b-row >
                <b-col md="6" sm="6" class="text-primary font-weight-bolder mt-1" @click="selectUserForAssessment(assessment)"><u>{{ assessment.title }}</u> </b-col>
                <b-col md="2" sm="3" class="text-info mt-1">{{ assessment.start_date }}</b-col>
                <b-col md="2" sm="3" class="text-info mt-1">{{ assessment.end_date }}</b-col>
                <b-col md="2" sm="3" class="text-info"><b-button variant="primary" @click="selectUserForAssessment(assessment)">SELECT</b-button></b-col>
            </b-row>
            <hr>
        </div>
      </b-card>
      <b-card v-if="isAssessmentSelected">
        <app-collapse>
            <app-collapse-item title="Click for Assessment Status" class="text-primary">
                <b-table
                    :items="userAssessmentStatusDisplay"
                    responsive
                    :fields="userAssessmentStatusFields"
                    class="mb-0"
                >
                    <template #cell(name)="data">
                        <div class="d-flex flex-column">
                            <a @click="getAssessmentQuestions(data.item.emp_id)">
                                <span class="font-weight-bolder text-primary mb-25"><u>{{ data.item.name }}</u></span>
                            </a>
                        </div>
                    </template>
                    <template #cell(manager)="data">
                        <div class="d-flex flex-column">
                            <span class="font-weight-bolder mb-25">{{ data.item.manager }}</span>
                        </div>
                    </template>
                    <template #cell(status)="data">
                        <div class="d-flex flex-column">
                            <span class="font-weight-bolder mb-25">{{ data.item.status }}</span>
                        </div>
                    </template>
                    <template #cell(rating)="data">
                        <div class="d-flex flex-column">
                            <span class="font-weight-bolder mb-25">{{ data.item.rating }}</span>
                        </div>
                    </template>
                </b-table>
            </app-collapse-item>    
        </app-collapse>

      </b-card>
      <b-card v-if="userList && (role === 'admin' || role === 'master' || role === 'account-manager' || isRecruiterAssessmentRole)">
        <b-row>
            <b-col md="4" sm="4" class="text-primary font-weight-bolder mt-0">
                Select User
            </b-col>
            <b-col md="4" sm="4">
                <v-select
                    id="user-list"
                    label="title"
                    placeholder="Select User"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="selectedUser"
                    :options="userList"
                    :reduce="(option) => option.emp_id"
                />
            </b-col>
            <b-col md="4" sm="4" class="text-center">
                <b-button variant="primary" @click="getAssessmentQuestions(selectedUser)">DONE</b-button>
            </b-col>
        </b-row>
      </b-card>
      <div v-if="questions && assessmentData">
        <div v-if="role === 'admin' || isRecruiterAssessmentRole || role === 'account-manager' || (role === 'master' && (assessmentData.isRecruiterDone || assessmentData.isTLDone || assessmentData.isFinalDone)) || emp_id == assessmentData.emp_id">
        <!-- <div v-if="role === 'admin' || role === 'talent-advisor-sourcer' || role === 'account-manager' || (role === 'master' && isTLDone && assessmentData.status === 'final')"> -->
        <div v-if="role === 'admin' || emp_id == assessmentData.emp_id || (isRecruiterAssessmentRole && !assessmentData.isRecruiterDone) || (role === 'account-manager' && emp_id != assessmentData.emp_id && assessmentData.isRecruiterDone ) || (role === 'master' && (assessmentData.isRecruiterDone || assessmentData.isTLDone || assessmentData.isFinalDone) )">
        <!-- <div class="demo-inline-spacing mb-2">
        </div> -->
        
        <b-card v-if="(isRecruiterAssessmentRole && assessmentData.isRecruiterDone) || (role === 'account-manager' && assessmentData.isTLDone) || ((role === 'admin' || role === 'master') && assessmentData.isFinalDone) || showEmployeeFinalSummaryCard">
            <p class="text-secondary ">Rating: 
                <span class="text-primary font-weight-bolder" v-if="showsFinalRatingBandText">{{ summaryRatingBand }} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;===> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    <span v-if="summaryRatingBand.includes('P1')"> Performance Below Expectations &nbsp; &nbsp; &nbsp; & &nbsp; &nbsp; &nbsp;</span>
                    <span v-if="summaryRatingBand.includes('P2')"> Performance Expectations Met &nbsp; &nbsp; &nbsp; & &nbsp; &nbsp; &nbsp;</span>
                    <span v-if="summaryRatingBand.includes('P3')"> Performance Exceeds Expectations &nbsp; &nbsp; &nbsp; & &nbsp; &nbsp; &nbsp;</span>
                    <span v-if="summaryRatingBand.includes('P4')"> Outstanding Performance &nbsp; &nbsp; &nbsp; & &nbsp; &nbsp; &nbsp;</span>
                    <span v-if="summaryRatingBand.includes('H1')"> Hygiene Below Expectations </span>
                    <span v-if="summaryRatingBand.includes('H2')"> Hygiene Expectations Met </span>
                    <span v-if="summaryRatingBand.includes('H3')"> Hygiene Exceeds Expectations </span>
                    <span v-if="summaryRatingBand.includes('H4')"> Oustanding Hygiene </span>
                </span>
                
                <span class="text-warning" v-else> Rating will be declared after Final Review !!! </span>
            </p>
            <p class="text-secondary font-weight-bolder" v-if="showsFinalFeedbackComment">Feedback Comment: </p>
            <p>
                <span class="text-info" v-if="showsFinalFeedbackComment" v-html="assessmentData.comment"></span>
            </p>
        </b-card>
        
        <employee-info class="mb-2" :employee-info="empStats.info" ></employee-info>
        
        <employee-stats
          v-if="showEmployeeStatistics"
          :employee-stats="empStats.statistics"
          :attendance="parseInt(empStats.info.attendance)"
        ></employee-stats>
        <b-row>
            <b-col  class="text-right">
                <b-button class="mr-2 mb-2" type="submit" variant="info" v-if="!checkIsDisabled" @click="saveResponses">Save Form</b-button>
            </b-col>
        </b-row>
        <!-- <employee-evaluation :employee-evaluation="employeeEvaluation"></employee-evaluation> -->
        <b-form @submit.prevent="submitResponses">
        
            <b-card v-for="(question, index) in questions"
                        :key="index"
            >
            <h4 class="text-primary text-center mb-1">Section - {{ question.section }}</h4>
            <!-- {{ question.questions }} -->
            <div class="px-3 mb-2 text-center">
                <!-- <span class="mb-0 "> <strong>Average Rating for Performance Section: </strong></span> -->
            </div>
            <!-- <ValidationObserver v-slot="{ invalid }"> -->
                
            <div
                v-for="(question, index) in question.questions"
                :key="index"
            >   
                <b-row class="mb-2">
                    <b-col cols="12" class="mb-1">
                        <strong>{{ question.text }}</strong>
                    </b-col>
                        <b-col cols="12" class="px-3 mb-0" v-if="canViewRecruiterResponseColumn">
                            <span class="mb-0" v-if="isTeamLeaderOrManager || isManager"> Recruiter Response</span>
                            <!-- Rating Dropdown -->
                            <b-col cols="12" class="mb-0">
                                <b-form-group>
                                    <b-form-radio-group
                                        v-model="question.rating"
                                        :options="ratingOptions"
                                        class="demo-inline-spacing"
                                        :name="'radio-inline-rec-' + question.id"
                                        :disabled="!canEditRecruiterFields"
                                        value-field="value"
                                        text-field="text"   
                                    />
                                </b-form-group>
                            </b-col>
                            <!-- Comment Box -->
                            <b-col cols="12" class="mb-0">
                                <b-form-group>
                                    <b-form-textarea 
                                        v-model="question.comment" 
                                        :disabled="!canEditRecruiterFields"
                                        rows="5"
                                        placeholder="Add Comment upto 300 characters">
                                    </b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-col>
                        <!-- <b-col cols="12" class="px-3 mb-0" v-if="role === 'admin' || (role === 'talent-advisor-sourcer' && assessmentData.isTLDone) || (role === 'account-manager' && (assessmentData.isRecruiterDone || emp_id === assessmentData.emp_id)) || (role === 'master' && assessmentData.isTLDone)"> -->
                        <b-col cols="12" class="px-3 mb-0" v-if="canViewTLResponseColumn">
                            <span class="mb-0" v-if="isTeamLeaderOrManager || isManager"> Team Leader Response</span>
                            <!-- Rating Dropdown -->
                            <b-col cols="12" class="mb-0">
                                <b-form-group>                                           
                                    <b-form-radio-group
                                        v-model="question.teamLeadRating"
                                        :options="ratingOptions"
                                        @change="display"
                                        class="demo-inline-spacing"
                                        :name="'radio-inline-team-' + question.id"
                                        :disabled="!canEditTLFields"
                                        value-field="value"
                                        text-field="text"    
                                    />
                                </b-form-group>
                            </b-col>
                            <!-- Comment Box -->
                            <b-col cols="12" class="mb-0">
                                <b-form-group>
                                    <b-form-textarea
                                        v-model="question.teamLeadComment" 
                                        :disabled="!canEditTLFields"
                                        rows="5"
                                        placeholder="Add Comment upto 300 characters">
                                    </b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-col>
                        <!-- <b-col cols="12" class="px-3 mb-0" v-if="role === 'admin' || (role === 'talent-advisor-sourcer' && assessmentData.isFinalDone) || (role === 'account-manager' && assessmentData.isFinalDone) || (role === 'master' && assessmentData.isTLDone)"> -->
                        <b-col cols="12" class="px-3 mb-0" v-if="canViewFinalResponseColumn">
                            <span class="mb-0"> Final Response</span>
                            <!-- Rating Dropdown -->
                            <b-col cols="12" class="mb-0">
                                <b-form-group>                                        
                                    <b-form-radio-group
                                        v-model="question.finalRating"
                                        :options="ratingOptions"
                                        class="demo-inline-spacing"
                                        :name="'radio-inline-final-' + question.id"
                                        :disabled="!canEditFinalFields"
                                        value-field="value"
                                        text-field="text"    
                                    />
                                </b-form-group>
                            </b-col>
                            <!-- Comment Box -->
                            <b-col cols="12" class="mb-0">
                                <b-form-group>
                                    <b-form-textarea 
                                        v-model="question.finalComment" 
                                        :disabled="!canEditFinalFields"
                                        rows="5"
                                        placeholder="Add Comment upto 300 characters">
                                    </b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-col>
                </b-row>
            </div>
                    
                    <!-- Submit Button -->
            <!-- </ValidationObserver> -->
        </b-card>
        <div class="text-center">
            <!-- <b-button class="mr-2" type="submit" variant="info">Save Form</b-button> -->
            <b-button type="submit" variant="primary" v-if="role === 'admin' || role === 'master'">Submit & Rate</b-button>
            <b-button type="submit" variant="primary" :disabled="checkIsDisabled" v-else>Submit</b-button>
        </div>
        </b-form>
        </div>
        
        <div class="text-danger text-center font-weight-bolder" v-else>
            <span >Recruiter Response Still Pending OR Team Leader Review Window Not Yet Started !!!</span>
        </div>
        </div>
        <div class="text-danger text-center font-weight-bolder" v-else>
            <span >Team Leader Response Still Pending OR Final Review Window Not Yet Started !!!</span>
        </div>
      </div>
      <div v-if="assessmentData">
      <b-card v-if="(isfinalRatingStarted || rating || comment || assessmentData.isFinalDone) && (role === 'admin' || role === 'master')" class="mt-2" id="finalratingform">
        <h4 class="text-primary text-center">Submit final Rating and comment</h4>
        <div class="demo-inline-spacing" v-if="calculatedFinalRating">
            <span class="font-weight-bolder" v-if="calculatedFinalRating.recruiter">Recruiter Rating: <span class="text-primary">{{ calculatedFinalRating.recruiter }}</span></span>
            <span class="font-weight-bolder" v-if="calculatedFinalRating.teamlead">Team Lead Rating: <span class="text-primary">{{ calculatedFinalRating.teamlead }}</span></span>
            <span class="font-weight-bolder" v-if="calculatedFinalRating.final">Rating Based on final Reponses: <span class="text-primary">{{ calculatedFinalRating.final }}</span></span>
            <span class="font-weight-bolder" v-if="calculatedFinalRating.final">Final Rating: <span class="text-primary">{{ calculatedFinalRating.final }}</span></span>
        </div>
        
        <b-form @submit.prevent="submitFinalRating">
            
            <div class="demo-inline-spacing">
                <b-form-group
                >
                    <v-select
                        style="width: 300px"
                        id="performance-rating"
                        label="text"
                        placeholder="Select Performance Rating"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        v-model="selectedPerformanceRating"
                        :options="performanceRatingOptions"
                    />
                </b-form-group>
                <b-form-group
                >
                    <v-select
                    style="width: 300px"
                    id="hygiene-rating"
                    label="text"
                    placeholder="Select Hygiene Rating"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="selectedHygieneRating"
                    :options="hygieneRatingOptions"
                />
                </b-form-group>
                <span class="font-weight-bolder mb-1">Selected Rating: <span class="text-primary">{{ this.selectedPerformanceRating }}{{ this.selectedHygieneRating }}</span></span>
            </div>
            <b-form-group>
                <quill-editor
                  v-model="comment"
                  :options="snowOption"
                  ref="final-comment"
                  style="height: 300px"
                />
            </b-form-group>
            <b-button type="submit" variant="primary" class="float-right mt-3" @click="submitFinalRating">Submit</b-button>
        </b-form>

      </b-card>
      </div>
      <!-- <div v-else>
            <span class="text-danger">No Questions Found for Selected Assessment</span>
      </div>   -->
      
    </div>
  </template>
  
  <script>
  import {
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormInvalidFeedback,
  BCard,
  BRow,
  BCol,
  BFormTextarea,
  BButton,
  BTable,
} from "bootstrap-vue";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import EmployeeStats from './EmployeeStats.vue';
  import EmployeeInfo from './EmployeeInfo.vue';
  import EmployeeEvaluation from './EmployeeEvaluation.vue';
  import RatingDropdown from './RatingDropdown.vue';
  import { quillEditor } from 'vue-quill-editor'
  import assessmentService from "@/services/assessment-service";
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import vSelect from "vue-select";

  export default {
    components: {
        EmployeeStats,
        EmployeeInfo,
        EmployeeEvaluation,
        RatingDropdown,
        BButton,
        BForm,
        BFormGroup,
        BFormRadioGroup,
        BFormRadio,
        // BFormInvalidFeedback,
        BCard,
        BRow,
        BCol,
        BFormTextarea,
        quillEditor,
        BTable,
        AppCollapse,
        AppCollapseItem,
        // Form Validation
        // ValidationProvider,
        // ValidationObserver,
        vSelect
    },
    data() {
      return {
        userStats: {}, // Fetch user stats from the backend
        questions: null,
        userAssessmentStatusFields: [
          { key: 'name', label: 'Name' },
          { key: 'manager', label: 'Manager' },
          { key: 'status', label: 'Status' },
          { key: 'rating', label: 'Final Rating' },
        ],
        // questions: [{ "qid": 1,text: 'How well do you rate yourself in generating revenue or contributing to the total revenue?', category: "Performance"},
        //     { "qid": 2,text: 'How well do you rate yourself in Profile Screening and JD study?', category: "Performance"},
        //     { "qid": 3,text: 'How well do you rate yourself in being versatile in sourcing?', category: "Performance"},
        //     { "qid": 4,text: 'How well do you rate yourself in building a rapport with your candidate and avoid having a drop?', category: "Performance"},
        //     { "qid": 5,text: 'How well do you rate yourself in sharing required number of CVs?', category: "Performance"}
        // ], // Fetch questions from the backend
        responses: null,
        empStats: null,
        // employeeStats: [
        //     {
        //         "parameter": "Revenue Generation",
        //         "avatar": "TrendingUpIcon",
        //         "actual_year": 200000,
        //         "expected_year": 250000,
        //         "actual_month": 200000,
        //         "expected_month": 250000
        //     },
        //     {
        //         "parameter": "Average profiles Shared Daily",
        //         "avatar": "UsersIcon",
        //         "actual_year": 10.5,
        //         "expected_year": 10,
        //         "actual_month": 10.5,
        //         "expected_month": 10
        //     },
        //     {
        //         "parameter": "Joiners per month",
        //         "avatar": "AwardIcon",
        //         "actual_year": 24,
        //         "expected_year": 48,
        //         "actual_month": 3,
        //         "expected_month": 72
        //     },
        //     {
        //         "parameter": "Selects per month",
        //         "avatar": "UserCheckIcon",
        //         "actual_year": 32,
        //         "expected_year": 72,
        //         "actual_month": 3,
        //         "expected_month": 72,
        //     },
        //     {
        //         "parameter": "Drops per Month",
        //         "avatar": "UserXIcon",
        //         "actual_year": 0.25,
        //         "expected_year": 0,
        //         "actual_month": 0.25,
        //         "expected_month": 0
        //     }
        // ],
        employeeStats: null,
        isRecruiterOrHigher: false,
        isManager: false,
        isTeamLeaderOrManager: false,
        employeeEvaluation: {
            rating: null,
            evaluation: []
        },
        ratingOptions: [
          { text: 'Below Expectations', value: { text: 'Below Expectations', value: 2 } },
          { text: 'Expectations Met', value: { text: 'Expectations Met', value: 3 } },
          { text: 'Exceeds Expectations', value: { text: 'Exceeds Expectations', value: 4 } },
          { text: 'Outstanding', value: { text: 'Outstanding', value: 5 } }
        ],
        snowOption: {
            theme: 'snow',
        },
        errors: null,  // Initialize with empty objects based on the number of questions,
        assessments: null,
        role: null,
        emp_id: null,
        name: null,
        userList: null,
        assessmentData: null,
        selectedUser: null,
        assessmentId: null,
        assessmentLevel: null,
        assessmentWeight: null,
        userAssessmentList: null,
        userAssessmentStatus: null,
        isfinalRatingStarted: false,
        calculatedFinalRating: null,
        finalResponses: null,
        rating: null,
        comment: null,
        selectedPerformanceRating: null,
        selectedHygieneRating: null,
        performanceRatingOptions: ['P1','P2','P3','P4','P5'],
        hygieneRatingOptions: ['H1','H2','H3','H4','H5'],
        isAssessmentSelected: false,
        //checkIsDisabled: false,

      };
    },
    computed: {
        isTalentAdvisorRole() {
            return this.role === 'talent-advisor-sourcer' || this.role === 'talent-advisor'
        },
        /** Same recruiter-stage UX as talent-advisor / talent-advisor-sourcer */
        isRecruiterAssessmentRole() {
            const roles = [
                'talent-advisor-sourcer',
                'talent-advisor',
                'bd',
                'sr-consultant-bd',
                'hr',
                'mis',
                'hr-director',
                'hr-manager',
                'hr-coordinator',
                'social-media-executive',
                'accountant',
                'finance',
            ]
            return Boolean(this.role && roles.includes(this.role))
        },
        /** 3-step flow: employee -> TL -> final (typically assessment.level === 3) */
        isThreeStepAssessment() {
            const n = Number(this.assessmentLevel)
            return n === 3 && !Number.isNaN(n)
        },
        isManagerReviewerRole() {
            return this.role === 'account-manager' || this.role === 'admin' || this.role === 'master'
        },
        /** bd/hr/mis/etc. — employee + manager final only (no TL column) */
        isOtherTwoStepRecruiterRole() {
            return this.isRecruiterAssessmentRole && !this.isTalentAdvisorRole
        },
        /** API may send assessment.level as string (e.g. "3"); strict === fails and hides recruiter inputs */
        isRecruiterAssessmentLevelNumeric() {
            const n = Number(this.assessmentLevel)
            return n === 3 && !Number.isNaN(n)
        },
        /** Show first-stage (employee) rating/comment column: TA/BD/etc., level-3 assessments, or managers after employee submit */
        showRecruiterResponseBlock() {
            const d = this.assessmentData
            if (!d) return false
            /* Admin / master: always show recruiter column for every assessment type and stage */
            if (this.role === 'admin' || this.role === 'master') return true
            if (this.isRecruiterAssessmentLevelNumeric) return true
            if (this.isRecruiterAssessmentRole) return true
            /* Self-appraisal: AM must see first-stage fields before isRecruiterDone; others' rows only after employee submit */
            if (this.role === 'account-manager' && (this.emp_id == d.emp_id || d.isRecruiterDone)) return true
            return false
        },
        canViewRecruiterResponseColumn() {
            const d = this.assessmentData
            if (!d || !this.showRecruiterResponseBlock) return false
            return (
                this.isRecruiterAssessmentRole
                || this.role === 'admin'
                || this.role === 'master'
                || (this.role === 'account-manager' && (this.emp_id == d.emp_id || d.isRecruiterDone))
            )
        },
        /** Current stage the logged-in user may save/submit (recruiter | teamlead | final) */
        submitStage() {
            const d = this.assessmentData
            if (!d || !this.questions) return null
            if (this.isRecruiterAssessmentRole && !d.isRecruiterDone) {
                return 'recruiter'
            }
            /* Admin / master can act from recruiter stage onward (was missing — submitStage stayed null) */
            if ((this.role === 'admin' || this.role === 'master') && !d.isRecruiterDone) {
                return 'recruiter'
            }
            /* Account manager self-appraisal: same as employee first stage — was never 'recruiter' so fields stayed disabled */
            if (this.role === 'account-manager' && this.emp_id == d.emp_id && !d.isRecruiterDone) {
                return 'recruiter'
            }
            const amReviewingOther = this.role === 'account-manager' && this.emp_id != d.emp_id
            /* TL step: only when AM is reviewing someone else; self-appraisal TL must be done by admin/master (or other higher role) */
            if (this.role === 'account-manager' && this.isThreeStepAssessment && d.isRecruiterDone && !d.isTLDone && amReviewingOther) {
                return 'teamlead'
            }
            /* Final per-question + band is admin/master only; AM never uses submitStage "final" */
            /* Admin / master: team lead stage (was missing — they could not submit TL before final) */
            if ((this.role === 'admin' || this.role === 'master') && this.isThreeStepAssessment && d.isRecruiterDone && !d.isTLDone) {
                return 'teamlead'
            }
            if ((this.role === 'admin' || this.role === 'master') && this.isThreeStepAssessment && d.isRecruiterDone && d.isTLDone && !d.isFinalDone) {
                return 'final'
            }
            if ((this.role === 'admin' || this.role === 'master') && !this.isThreeStepAssessment && d.isRecruiterDone && !d.isFinalDone) {
                return 'final'
            }
            return null
        },
        canEditRecruiterFields() {
            return Boolean(this.canViewRecruiterResponseColumn && this.assessmentData && this.submitStage === 'recruiter')
        },
        /** TL column only for 3-step assessments; admin/master always see it (read-only until stage); AM after employee submit */
        canViewTLResponseColumn() {
            const d = this.assessmentData
            if (!d || !this.isThreeStepAssessment) return false
            if (this.role === 'admin' || this.role === 'master') return true
            if (!this.isManagerReviewerRole) return false
            return d.isRecruiterDone
        },
        canEditTLFields() {
            return Boolean(this.canViewTLResponseColumn && this.assessmentData && this.submitStage === 'teamlead')
        },
        /** Final: managers after TL done (3-step) or after employee done (2-step); admin/master always see column; employees read-only when published */
        canViewFinalResponseColumn() {
            const d = this.assessmentData
            if (!d) return false
            if (this.role === 'admin' || this.role === 'master') return true
            /* AM / TA: per-question final column only after final rating + comment are published */
            if (this.role === 'account-manager') {
                return !!d.isFinalDone
            }
            if (this.isTalentAdvisorRole && this.emp_id == d.emp_id) {
                return !!d.isFinalDone
            }
            /* Other employees (non-TA roles): read-only final when band/comment/status indicate publish */
            if (this.emp_id == d.emp_id && !this.isManagerReviewerRole) {
                if (d.isFinalDone) return true
                const st = String(d.status || '').toLowerCase()
                if (d.rating && String(d.rating).trim()) return true
                if (d.comment != null && String(d.comment).trim()) return true
                if (/final|completed|rating/.test(st)) return true
                return this.hasAnyPerQuestionFinalContent
            }
            return false
        },
        canEditFinalFields() {
            return Boolean(this.canViewFinalResponseColumn && this.assessmentData && this.submitStage === 'final')
        },
        checkIsDisabled() {
            return this.submitStage === null
        },
        /** Operations dept (from assessed employee info): show employee-stats; otherwise employee-info only */
        showEmployeeStatistics() {
            const info = this.empStats && this.empStats.info
            if (!info) return false
            const dept = (info.department || info.dept || '').trim().toLowerCase()
            return dept === 'operations'
        },
        /** Status table: API `statusData` rows often omit `rating`; merge from `userAssessmentList`. */
        userAssessmentStatusDisplay() {
            const status = this.userAssessmentStatus
            const list = this.userAssessmentList
            if (!status || !Array.isArray(status)) return []
            if (!list || !Array.isArray(list)) return status
            return status.map(row => {
                const match = list.find(u => u.emp_id == row.emp_id)
                const r = row.rating != null && String(row.rating).trim() !== ''
                    ? row.rating
                    : (match && match.rating != null ? match.rating : '')
                return { ...row, rating: r }
            })
        },
        hasAnyPerQuestionFinalContent() {
            if (!this.questions || !Array.isArray(this.questions)) return false
            for (let s = 0; s < this.questions.length; s += 1) {
                const qs = this.questions[s].questions
                if (!qs) continue
                for (let i = 0; i < qs.length; i += 1) {
                    const q = qs[i]
                    if (q.finalRating != null || (q.finalComment != null && String(q.finalComment).trim())) return true
                }
            }
            return false
        },
        /** Prefer row `rating`; else computed band from per-question finals (employee API row often omits `rating`). */
        summaryRatingBand() {
            const d = this.assessmentData
            if (d && d.rating && String(d.rating).trim()) return String(d.rating).trim()
            const cf = this.calculatedFinalRating && this.calculatedFinalRating.final
            return cf ? String(cf) : ''
        },
        /** Employee summary card when final band/comment exist even if `isFinalDone` flag missing from their API row */
        showEmployeeFinalSummaryCard() {
            const d = this.assessmentData
            if (!d || this.emp_id != d.emp_id) return false
            if (this.isTalentAdvisorRole || (this.role === 'account-manager' && this.emp_id == d.emp_id)) {
                return !!d.isFinalDone
            }
            if (d.isFinalDone) return true
            const st = String(d.status || '').toLowerCase()
            if (/final|completed|rating/.test(st)) return true
            if (d.rating && String(d.rating).trim()) return true
            if (d.comment != null && String(d.comment).trim()) return true
            if (this.hasAnyPerQuestionFinalContent) return true
            return false
        },
        /** P1H1 band line: employees see whenever a band string exists; managers when final is done */
        showsFinalRatingBandText() {
            const band = this.summaryRatingBand
            if (!band) return false
            const d = this.assessmentData
            if (!d) return false
            if (this.isTalentAdvisorRole && this.emp_id == d.emp_id) {
                return !!d.isFinalDone
            }
            if (this.role === 'account-manager' && this.emp_id == d.emp_id) {
                return !!d.isFinalDone
            }
            if (this.emp_id == d.emp_id) return true
            if (this.role === 'admin' || this.role === 'master' || this.role === 'account-manager') {
                return !!d.isFinalDone
            }
            return false
        },
        showsFinalFeedbackComment() {
            const d = this.assessmentData
            if (!d || d.comment == null || !String(d.comment).trim()) return false
            if (this.isTalentAdvisorRole && this.emp_id == d.emp_id) {
                return !!d.isFinalDone
            }
            if (this.role === 'account-manager' && this.emp_id == d.emp_id) {
                return !!d.isFinalDone
            }
            if (this.emp_id == d.emp_id) return true
            const mgr = this.role === 'admin' || this.role === 'master' || this.role === 'account-manager'
            return mgr && !!d.isFinalDone
        },
    },
    created() {
        console.log('in created: ', this.role)
      // Fetch questions and user stats on component creation
      const userData = JSON.parse(localStorage.getItem('userData'));
      this.emp_id = userData.emp_id
      this.role = userData.roles[0].toLowerCase()
      this.name = userData.first_name + ' ' + userData.last_name

      this.getActiveAssessments()
      if (this.role === 'admin' || this.role === 'master' || this.role === 'hr' || this.role === 'hr-director' || this.role === 'hr-manager' || this.role === 'hr-coordinator') {
        this.isManager = true
        this.isTeamLeaderOrManager = true
        this.isRecruiterOrHigher = true
    } else if (this.role === 'account-manager' || this.role === 'admin' || this.role === 'master' || this.role === 'hr') {
        this.isTeamLeaderOrManager = true
        this.isRecruiterOrHigher = true
    } else if (this.role === 'talent-advisor-sourcer' || this.role === 'talent-advisor' || this.role === 'account-manager' || this.role === 'admin' || this.role === 'master' || this.role === 'hr' || this.role === 'bd' || this.role === 'sr-consultant-bd' || this.role === 'mis' || this.role === 'accountant' || this.role === 'finance' || this.role === 'social-media-executive') {
        this.isRecruiterOrHigher = true
    }
    },
    methods: {
    
      isDisabled(role,currentStage) {
        const order = ['recruiter', 'teamLeader', 'final'];
        //console.log('is disabled: ', role, currentStage, order.indexOf(currentStage), order.indexOf(role))
        return order.indexOf(currentStage) < order.indexOf(role);
      },
      display() {
        console.log('display: ',this.questions)
      },
      calcRating() {
        const evaluation = []
        this.responses.forEach(response => {
            const question = this.questions.filter(item => item.qid === response.qid)[0].text
            const category = this.questions.filter(item => item.qid === response.qid)[0].category

            const item = {
                question: question,
                empRating: response.rating,
                teamRating: response.teamLeadRating,
                finalRating: response.finalRating,
                category: category
            }

            evaluation.push(item)
            // const performanceEvaluation=  evaluation.filter(item => item.category === 'Performance')
            // const hygieneEvaluation=  evaluation.filter(item => item.category === 'Hygiene')

            // this.employeeEvaluation = {
            //     performance : performanceEvaluation,
            //     hygiene: hygieneEvaluation
            // }
        })
        let cumulativeScore = evaluation.reduce((total, question) => {
            let rating = this.ratingOptions.filter(option => option.text === question.finalRating)[0];
            return total + (rating ? rating.value : 0);
        }, 0);
        console.log('score: ', cumulativeScore)
        let averageScore = cumulativeScore / evaluation.length;
        console.log('avg score: ', averageScore)
        let closestRating = this.ratingOptions.reduce((prev, curr) => {
            return (Math.abs(curr.value - averageScore) < Math.abs(prev.value - averageScore) ? curr : prev);
        });

        let correspondingRating = closestRating.text;

        return {
            rating: correspondingRating,
            evaluation : evaluation
        }
        //console.log(this.employeeEvaluation)
      },
      getActiveAssessments() {
        assessmentService.getActiveAssessments(this.emp_id, this.role).then(res => {
            if (res.status === "OK") {
                this.assessments = res.data;
                console.log('assessments: ', this.assessments)
            } else if ((res.status === 401 ) || (res.status === 403 )) {
                window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
                localStorage.clear();
                this.$router.push({ name: "auth-login" });
            } else {
                alert("Error fetching active assessments" + res);
            }
        })
      },
      /** After save/submit, refetch row + questions so flags (isRecruiterDone, etc.) and status table stay in sync */
      refreshAssessmentStateAfterWrite() {
        if (!this.assessmentId || this.selectedUser == null) return
        assessmentService.getUserAssignedToAssessments(this.emp_id, this.assessmentId, this.role).then(res => {
            if (res.status === 'OK') {
                this.userAssessmentList = res.data
                this.userAssessmentStatus = res.statusData
                const row = this.userAssessmentList.filter(item => item.emp_id == this.selectedUser)[0]
                if (row) {
                    this.assessmentData = { ...row }
                }
                this.getAssessmentQuestions(this.selectedUser)
            }
        })
      },
      selectUserForAssessment(assessment) {
        this.isAssessmentSelected = true
        this.selectedUser = null
        this.assessmentId = assessment.id
        this.assessmentWeight = assessment.weight
        this.assessmentLevel = assessment.level
        assessmentService.getUserAssignedToAssessments(this.emp_id, assessment.id, this.role).then(res => {
            if (res.status === "OK") {
                this.userAssessmentList = res.data
                this.userAssessmentStatus = res.statusData
                console.log('Select user for assessment: ',this.userAssessmentList, this.userAssessmentStatus)

                //if(this.role === 'admin' || this.role === 'master' || this.role === 'account-manager') {
                if(this.role === 'admin' || this.role === 'master' || this.role === 'account-manager' || this.isRecruiterAssessmentRole) {    
                    let allUsers = JSON.parse(localStorage.getItem('allusers'));

                    console.log('allUsers', allUsers)
                    this.userList = this.userAssessmentList.map(emp => {
                    // Find the title object in the titles array that matches the current employee's emp_id
                        const titleObj = allUsers.find(title => title.emp_id === emp.emp_id);
                        
                        // Return a new object with emp_id and title
                        // If titleObj is not found, return undefined for the title
                        return {
                            emp_id: emp.emp_id,
                            title: titleObj ? titleObj.title : undefined
                        };
                    });
                    // if(this.role === 'account-manager') {
                    //     this.userList.push({emp_id: this.emp_id, title: this.name})
                    // }
                    
                } else {
                    let user = JSON.parse(localStorage.getItem('userData')).emp_id;
                    this.assessmentData = this.userAssessmentList[0]
                    this.getAssessmentQuestions(user)
                }
            }
        }) 
      },
      getAssessmentQuestions(user) {

        if(this.role === 'admin' || this.role === 'master' || this.role === 'account-manager' || this.isRecruiterAssessmentRole) {
            console.log('Selected User', this.selectedUser, user)
            this.selectedUser = user
            this.assessmentData = this.userAssessmentList.filter(item => item.emp_id == user)[0]
            console.log('Selected assessment', this.assessmentData)
            if (!this.assessmentData) {
                console.warn('EmployeeAppraisal: no assessment row for emp_id', user)
                return
            }
            this.rating = this.assessmentData.rating || null
            this.comment = this.assessmentData.comment || null
        } else {
            this.selectedUser = this.emp_id
        }
        assessmentService.getEmployeeStats(this.selectedUser).then(res => {
            if(res.status == "OK"){
                this.empStats = res.data
                console.log('Employee Stats: ', this.empStats)
            }
        })
        assessmentService.getAssessmentQuestions(this.selectedUser, this.assessmentId).then(res => {
            if (res.status == "OK"){
                const questions = res.data
                this.questions = []
                
                const uniqueCategories = questions.reduce((acc, question) => {
                    acc.add(question.category);
                    return acc;
                }, new Set());

                

                // Convert the Set back into an array
                const uniqueCategoriesArray = Array.from(uniqueCategories);

                console.log(uniqueCategoriesArray);

                uniqueCategoriesArray.forEach(category => {
                    let categoryQuestions = questions.filter(ques => ques.category === category);
                    console.log(categoryQuestions)
                    this.questions.push({
                        section: category.toUpperCase(),
                        questions: categoryQuestions,
                           
                    })
                    
                })
                const mergedQuestions = this.mergeQuestionsAndSelectedKeys(this.questions)
                if (mergedQuestions && mergedQuestions.length) {
                    this.calculatedFinalRating = this.calculateFinalRating(mergedQuestions)
                }
                if(this.role === 'admin' || this.role === 'master') {
                        console.log('mergedQuestions from questions: ', mergedQuestions)
                        this.finalResponses = {}
                        this.finalResponses.responses = mergedQuestions
                        this.finalResponses.emp_id = this.selectedUser
                        this.finalResponses.assessment_id = this.assessmentId
                        this.finalResponses.updated_by = this.emp_id
                        this.finalResponses.assessmentLevel = this.assessmentLevel
                        this.finalResponses.role = this.role
                        
                    // this.finalResponses = this.getResponses('')
                    // console.log('responses from get assessment questions: ', this.finalResponses)
                    console.log('mergedQuestions:', mergedQuestions )
                }
                
            }
        })
      },
      saveResponses() {
        const response = this.getResponses('save')
        if (!response || !response.responses || !response.responses.length) {
            console.warn('[EmployeeAppraisal][saveResponses] Empty payload; skip API')
            return
        }
        this.finalResponses = response
        console.log('save response: ', response, this.finalResponses)
        assessmentService.updateAssessmentAndResponses(this.finalResponses).then(res => {
            if (res.status == "OK"){
                console.log(res)

                
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Responses save Successful',
                        icon: 'EditIcon',
                        variant: 'success',
                        timeout: 5000,
                },
              })
                this.refreshAssessmentStateAfterWrite()
            }
        })
      },
      submitResponses() {
        const response = this.getResponses('submit')
        console.log('[EmployeeAppraisal][submitResponses] role:', this.role, 'assessmentLevel:', this.assessmentLevel)
        console.log('[EmployeeAppraisal][submitResponses] payload from getResponses:', response)
        this.finalResponses = response
        if (!this.finalResponses || !this.finalResponses.responses || !this.finalResponses.responses.length) {
            console.warn('[EmployeeAppraisal][submitResponses] Empty/invalid payload. Skipping API call.', this.finalResponses)
            return
        }
        if(this.role !== 'admin' && this.role !== 'master') {
            console.log('[EmployeeAppraisal][submitResponses] calling updateAssessmentAndResponses...')
            assessmentService.updateAssessmentAndResponses(this.finalResponses).then(res => {
                console.log('[EmployeeAppraisal][submitResponses] API response:', res)
                if (res.status == "OK"){
                    console.log('[EmployeeAppraisal][submitResponses] submit successful')
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Responses Submit Successful',
                            icon: 'EditIcon',
                            variant: 'success',
                            timeout: 5000,
                        },
                })
                    this.refreshAssessmentStateAfterWrite()
                }
            }).catch(err => {
                console.error('[EmployeeAppraisal][submitResponses] API error:', err)
            })
        }   
        
      },
      submitFinalResponses(response) {
        
        this.isfinalRatingStarted = true
        console.log('in final submit response: ',response)
        
        this.calculatedFinalRating = this.calculateFinalRating(response.responses)
        console.log('calculated Final Rating: ', this.calculatedFinalRating)
        this.scrollToElement()
        response.isFinalDone = true
        if (this.isThreeStepAssessment) {
            response.isTLDone = true
        }
        response.final_rating_submitted_by = this.emp_id
        //response.added_by = this.emp_id
        //response.updated_by = this.emp_id
        this.finalResponses = response
        assessmentService.updateAssessmentAndResponses(this.finalResponses).then(res => {
            if (res.status == "OK"){
                console.log(res)
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Responses Submit Successful',
                        icon: 'EditIcon',
                        variant: 'success',
                        timeout: 5000,
                    },
              })
                this.refreshAssessmentStateAfterWrite()
            }
        })
        
      },
      submitFinalRating() {
        console.log('final rating sumit method:', this.finalResponses, this.selectedPerformanceRating, this.selectedHygieneRating, this.comment)
        this.finalResponses.rating = this.selectedPerformanceRating + '' + this.selectedHygieneRating
        this.finalResponses.comment = this.comment
        this.finalResponses.isFinalDone = true
        if (this.isThreeStepAssessment) {
            this.finalResponses.isTLDone = true
        }
        this.finalResponses.final_rating_submitted_by = this.emp_id
        if (Array.isArray(this.finalResponses.responses)) {
            this.finalResponses.responses = this.finalResponses.responses.map(r => ({
                ...r,
                final_rating_submitted_by: this.emp_id,
                final_rating_added_by: r.final_rating_added_by != null ? r.final_rating_added_by : this.emp_id,
            }))
        }
        console.log('final rating sumit method final:', this.finalResponses)
        assessmentService.updateAssessmentAndResponses(this.finalResponses).then(res => {
            if (res.status == "OK"){
                console.log(res)
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Responses Update Successful',
                        icon: 'EditIcon',
                        variant: 'success',
                        timeout: 5000,
                    },
              })
                this.refreshAssessmentStateAfterWrite()
            }
        })
      },
      scrollToElement() {
        const el = 'finalratingform';
        this.$nextTick(() => {
            if (el) {
                document.getElementById(el).scrollIntoView();
            }
         //   document.getElementById('elementId').scrollIntoView();
        });
        
        console.log('element', el)
        
      },
      mergeQuestionsFull(array) {
        if (!array) return null
        const stampFinalAddedBy = this.role === 'admin' || this.role === 'master'
        return array.reduce((acc, section) => {
            const selectedQuestions = section.questions.map(question => {
                const row = {
                    question_id: question.id,
                    category: (question.category || '').toLowerCase(),
                    rating: question.rating,
                    comment: question.comment,
                    teamLeadRating: question.teamLeadRating,
                    teamLeadComment: question.teamLeadComment,
                    finalRating: question.finalRating,
                    finalComment: question.finalComment,
                    assessment_id: question.assessment_id,
                }
                if (stampFinalAddedBy) {
                    row.final_rating_added_by = this.emp_id
                }
                return row
            })
            return [...acc, ...selectedQuestions]
        }, [])
      },
      mergeQuestionsAndSelectedKeys(array) {
        return this.mergeQuestionsFull(array)
      },
      buildRecruiterPayload(merged, type, userData) {
            const isSubmit = type === 'submit'
            const responses = merged.map(row => ({
                question_id: row.question_id,
                assessment_id: row.assessment_id,
                category: row.category,
                rating: row.rating,
                comment: row.comment,
                teamLeadRating: null,
                teamLeadComment: null,
                finalRating: null,
                finalComment: null,
            }))
            /*
             * Backend often keys the first (employee) stage on recruiter-facing roles only.
             * Self-appraisal as account-manager / master / admin with role=account-manager was not persisting.
             */
            const isSelfAppraisal = this.emp_id == this.selectedUser
            let payloadRole = this.role
            if (isSelfAppraisal && (this.role === 'account-manager' || this.role === 'master' || this.role === 'admin')) {
                payloadRole = 'talent-advisor-sourcer'
            }
            return {
                responses,
                mgr_id: userData.mgr_id,
                p_mgr_id: userData.p_mgr_id,
                emp_id: this.selectedUser,
                assessment_id: this.assessmentId,
                added_by: this.emp_id,
                updated_by: this.emp_id,
                assessmentLevel: Number(this.assessmentLevel),
                role: payloadRole,
                isRecruiterDone: isSubmit,
            }
      },
      buildTLPayload(merged, type) {
            const isSubmit = type === 'submit'
            const responses = merged.map(row => ({
                question_id: row.question_id,
                assessment_id: row.assessment_id,
                category: row.category,
                rating: null,
                comment: null,
                teamLeadRating: row.teamLeadRating,
                teamLeadComment: row.teamLeadComment,
                finalRating: null,
                finalComment: null,
            }))
            return {
                responses,
                emp_id: this.selectedUser,
                assessment_id: this.assessmentId,
                updated_by: this.emp_id,
                assessmentLevel: Number(this.assessmentLevel),
                role: this.role,
                isTLDone: isSubmit,
            }
      },
      buildFinalPayload(merged, type) {
            const isSubmit = type === 'submit'
            const responses = merged.map(row => {
                const item = {
                    question_id: row.question_id,
                    assessment_id: row.assessment_id,
                    category: row.category,
                    rating: null,
                    comment: null,
                    teamLeadRating: null,
                    teamLeadComment: null,
                    finalRating: row.finalRating,
                    finalComment: row.finalComment,
                }
                if (row.final_rating_added_by != null) {
                    item.final_rating_added_by = row.final_rating_added_by
                }
                if (isSubmit) {
                    item.final_rating_submitted_by = this.emp_id
                    if (item.final_rating_added_by == null) {
                        item.final_rating_added_by = this.emp_id
                    }
                }
                return item
            })
            const payload = {
                responses,
                emp_id: this.selectedUser,
                assessment_id: this.assessmentId,
                updated_by: this.emp_id,
                assessmentLevel: Number(this.assessmentLevel),
                role: this.role,
                isFinalDone: isSubmit,
            }
            /* 3-step: TL stage may be skipped in DB when final reviewer submits; backend / employee UI expect isTLDone */
            if (isSubmit && this.isThreeStepAssessment) {
                payload.isTLDone = true
            }
            if (isSubmit) {
                payload.final_rating_submitted_by = this.emp_id
            }
            return payload
      },
      /** True if a radio rating is selected (handles nested { value: { value: n } } from b-form-radio-group). */
      isRatingProvided(rating) {
        if (rating == null) return false
        const n = this.extractRatingNumeric(rating)
        if (n != null && !Number.isNaN(n)) return true
        if (typeof rating === 'object' && rating.value != null && typeof rating.value === 'object') {
          return this.extractRatingNumeric(rating.value) != null
        }
        return !!(typeof rating === 'object' && rating.text && String(rating.text).trim())
      },
      /** Non-empty comment (plain text or simple HTML from editors). */
      isCommentProvided(comment) {
        if (comment == null) return false
        const s = String(comment).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
        return s.length > 0
      },
      /**
       * On submit only: every question must have rating + comment for the active stage.
       * @returns {string|null} error message or null if OK
       */
      getSubmitValidationError(stage, mergedRows) {
        if (!stage || !mergedRows || !mergedRows.length) return null
        const missing = []
        mergedRows.forEach((row, idx) => {
          const label = row.question_id != null ? `Q${row.question_id}` : `Question ${idx + 1}`
          if (stage === 'recruiter') {
            if (!this.isRatingProvided(row.rating)) missing.push(`${label}: employee / recruiter rating`)
            if (!this.isCommentProvided(row.comment)) missing.push(`${label}: employee / recruiter comment`)
          } else if (stage === 'teamlead') {
            if (!this.isRatingProvided(row.teamLeadRating)) missing.push(`${label}: team leader rating`)
            if (!this.isCommentProvided(row.teamLeadComment)) missing.push(`${label}: team leader comment`)
          } else if (stage === 'final') {
            if (!this.isRatingProvided(row.finalRating)) missing.push(`${label}: final rating`)
            if (!this.isCommentProvided(row.finalComment)) missing.push(`${label}: final comment`)
          }
        })
        if (!missing.length) return null
        const max = 6
        const head = missing.slice(0, max).join('; ')
        const tail = missing.length > max ? ` (+${missing.length - max} more)` : ''
        return `Each question needs a rating and a comment. Missing: ${head}${tail}`
      },
      toastValidationError(text) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Cannot submit',
            text,
            icon: 'AlertCircleIcon',
            variant: 'danger',
            timeout: 8000,
          },
        })
      },
      getResponses(type) {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const stage = this.submitStage
        console.log('[EmployeeAppraisal][flow] type:', type, 'submitStage:', stage, 'threeStep:', this.isThreeStepAssessment, 'role:', this.role, 'TA:', this.isTalentAdvisorRole, 'other2step:', this.isOtherTwoStepRecruiterRole)
        console.log('[EmployeeAppraisal][getResponses] assessmentLevel:', this.assessmentLevel)

        const mergedQuestions = this.mergeQuestionsFull(this.questions)
        console.log('[EmployeeAppraisal][getResponses] mergedQuestions length:', mergedQuestions ? mergedQuestions.length : 0)
        if (type === 'submit' && stage && mergedQuestions && mergedQuestions.length) {
          const verr = this.getSubmitValidationError(stage, mergedQuestions)
          if (verr) {
            this.toastValidationError(verr)
            return {}
          }
        }
        if (mergedQuestions && mergedQuestions.length && stage === 'recruiter') {
            const fr = this.buildRecruiterPayload(mergedQuestions, type, userData)
            if (fr.responses && fr.responses[0]) {
                console.log('[EmployeeAppraisal][flow] recruiter payload sample[0]:', fr.responses[0])
            }
            console.log('[EmployeeAppraisal][getResponses] returning recruiter payload, isRecruiterDone:', fr.isRecruiterDone)
            return fr
        }
        if (mergedQuestions && mergedQuestions.length && stage === 'teamlead') {
            const fr = this.buildTLPayload(mergedQuestions, type)
            if (fr.responses && fr.responses[0]) {
                console.log('[EmployeeAppraisal][flow] TL payload sample[0]:', fr.responses[0])
            }
            console.log('[EmployeeAppraisal][getResponses] returning TL payload, isTLDone:', fr.isTLDone)
            return fr
        }
        if (mergedQuestions && mergedQuestions.length && stage === 'final') {
            const fr = this.buildFinalPayload(mergedQuestions, type)
            if (fr.responses && fr.responses[0]) {
                console.log('[EmployeeAppraisal][flow] final payload sample[0]:', fr.responses[0])
            }
            console.log('[EmployeeAppraisal][getResponses] returning final payload, isFinalDone:', fr.isFinalDone)
            if ((this.role === 'admin' || this.role === 'master') && type === 'submit') {
                this.submitFinalResponses(fr)
            }
            return fr
        }
        console.warn('[EmployeeAppraisal][getResponses] no matching stage or empty merge; returning {}')
        return {}
      },
      /** Numeric 1–5 from v-model object or primitive */
      extractRatingNumeric(rating) {
            if (rating == null) return null
            if (typeof rating === 'object' && rating.value != null) {
                const n = Number(rating.value)
                return Number.isNaN(n) ? null : n
            }
            const n = Number(rating)
            return Number.isNaN(n) ? null : n
      },
      /** Map average score to band 1–5 (stable across question counts) */
      averageToBand(avg) {
            if (avg == null || Number.isNaN(avg)) return 1
            if (avg < 1.5) return 1
            if (avg < 2.5) return 2
            if (avg < 3.5) return 3
            if (avg < 4.5) return 4
            return 5
      },
      computeStageBandFromResponses(responses, fieldKey) {
            if (!responses || !responses.length) return null
            const perf = []
            const hyg = []
            responses.forEach(r => {
                const cat = (r.category || '').toLowerCase()
                const v = this.extractRatingNumeric(r[fieldKey])
                if (v == null) return
                if (cat === 'performance') perf.push(v)
                else if (cat === 'hygiene') hyg.push(v)
            })
            const pBand = perf.length ? this.averageToBand(perf.reduce((a, b) => a + b, 0) / perf.length) : 1
            const hBand = hyg.length ? this.averageToBand(hyg.reduce((a, b) => a + b, 0) / hyg.length) : 1
            return `P${pBand}H${hBand}`
      },
      calculateFinalRating(responses) {
            const d = this.assessmentData
            const calcRating = { recruiter: null, teamlead: null, final: null }
            if (!d || !responses || !responses.length) return calcRating
            if (d.isRecruiterDone) {
                calcRating.recruiter = this.computeStageBandFromResponses(responses, 'rating')
            }
            if (d.isTLDone) {
                calcRating.teamlead = this.computeStageBandFromResponses(responses, 'teamLeadRating')
            }
            const anyFinalQuestion = responses.some(r => r.finalRating != null)
            if (d.isFinalDone || this.isfinalRatingStarted || anyFinalQuestion) {
                calcRating.final = this.computeStageBandFromResponses(responses, 'finalRating')
            }
            console.log('[EmployeeAppraisal][calculateFinalRating]', calcRating)
            return calcRating
      },
    },
    
  };
  </script>
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  @import '@core/scss/vue/libs/quill.scss';

  .collapse-title {
    text-decoration: underline;
    text-align: center;
    
  }
  </style>